module.exports = __webpack_public_path__ + "2fd91ec3ea70a6e39bf01563eb300754.pdf";